import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import {
    Button,
    ButtonContainer,
    Title,
    Grid,
    Row,
    Form,
    FormLine,
    FormLabel,
    FormInput,
    FormTextarea,
    FormField,
} from 'yurstrap';

import AutoSelect from '../../../components/AutoSelect';

import {
    checkName,
    checkMessage,
    checkEmail,
    checkEventType,
    salesmanFormHasErrors,
} from '../../constants/FieldsValidation';

import { getItemSelector as getMeSelector } from '../../../commons/reduxModules/APIMe';

import {
    getItemsSelector as getEventTypesSelector,
    isLoadingSelector as isEventTypesLoadingSelector,
} from '../../../commons/reduxModules/APIEventTypes';

import {
    proUrl,
    externalUrl,
} from '../../../config';

import {
    getCurrentOrgaSelector,
    setCurrentEventType,
    getCurrentEventTypeSelector,
    setCurrentPhone,
    getCurrentPhoneSelector,
    setCurrentEmail,
    setCurrentMessage,
    getCurrentMessageSelector,
    postSalesmanThread,
    getCurrentEmailSelector,
    isQuestionErrorsDisplayedSelector,
    getCurrentNameSelector,
    setCurrentName,
} from '../../reduxModules/App';
import BackLink from '../BackLink';

const propTypes = {
    AppActions: PropTypes.shape({
        setCurrentEventType: PropTypes.func.isRequired,
        setCurrentPhone: PropTypes.func.isRequired,
        setCurrentEmail: PropTypes.func.isRequired,
        setCurrentMessage: PropTypes.func.isRequired,
        postSalesmanThread: PropTypes.func.isRequired,
        setCurrentName: PropTypes.func.isRequired,
    }).isRequired,
    currentEventType: PropTypes.string,
    orga: PropTypes.object,
    user: PropTypes.object,
    eventTypes: PropTypes.array.isRequired,
    isEventTypesLoading: PropTypes.bool.isRequired,
    questionErrorsDisplayed: PropTypes.bool.isRequired,
    phone: PropTypes.string,
    message: PropTypes.string,
    currentEmail: PropTypes.string,
    currentName: PropTypes.string,
};

const defaultProps = {
    currentName: '',
    currentEmail: '',
    message: '',
    phone: '',
    currentEventType: '',
    orga: null,
    user: null,
};

export class ContactSalesman extends Component {

    constructor(props) {
        super(props);
        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeEventTypes = this.onChangeEventTypes.bind(this);
        this.onChangePhone = this.onChangePhone.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeMessage = this.onChangeMessage.bind(this);
        this.onSendRequest = this.onSendRequest.bind(this);
        this.renderNoOptionsMessage = this.renderNoOptionsMessage.bind(this);
        this.renderOptionsValue = this.renderOptionsValue.bind(this);
    }

    onChangeName(e) {
        const { AppActions } = this.props;
        const { value } = e.target;
        AppActions.setCurrentName(value);
    }

    onChangePhone(e) {
        const {
            AppActions,
        } = this.props;
        const { value } = e.target;
        AppActions.setCurrentPhone(value);
    }

    onChangeEmail(e) {
        const {
            AppActions,
        } = this.props;
        const { value } = e.target;
        AppActions.setCurrentEmail(value);
    }

    onChangeEventTypes(value) {
        const {
            AppActions,
        } = this.props;
        AppActions.setCurrentEventType(value);
    }

    onChangeMessage(e) {
        const { AppActions } = this.props;
        const { value } = e.target;
        AppActions.setCurrentMessage(value);
    }

    onSendRequest() {
        const { AppActions } = this.props;
        AppActions.postSalesmanThread();
    }

    renderOptionsValue(option) {
        return option.name;
    }

    renderOrgaName() {
        const {
            orga,
            user,
            currentName,
            questionErrorsDisplayed,
        } = this.props;
        const windowLocation = window.location.origin;
        let content = 'Nom de votre organisation*';
        if (windowLocation === externalUrl) {
            content = 'Nom';
        }
        const orgaName = orga ? orga.name : '';
        const userName = user ? `${user.first_name} ${user.last_name}` : '';
        const validationEmailStatus = !questionErrorsDisplayed
            || checkName(orgaName)
            || checkName(userName)
            || checkName(currentName);
        return (
            <FormLine
                status={validationEmailStatus ? 'standard' : 'error'}
                className="u-col--m-6 u-col--s-12"
            >
                <FormLabel>
                    {content}
                </FormLabel>
                <FormInput
                    required
                    defaultValue={windowLocation === proUrl ? orgaName : userName}
                    onChange={this.onChangeName}
                />
            </FormLine>
        );
    }

    renderPhone() {
        const { phone } = this.props;
        return (
            <FormLine className="u-col--m-6 u-col--s-12">
                <FormLabel>
                    Téléphone
                </FormLabel>
                <FormInput
                    type="tel"
                    defaultValue={phone}
                    onChange={this.onChangePhone}
                />
            </FormLine>
        );
    }

    renderEmail() {
        const {
            user,
            currentEmail,
            questionErrorsDisplayed,
        } = this.props;
        const userEmail = user ? user.email_address : '';
        const validationEmailStatus = !questionErrorsDisplayed
            || checkEmail(userEmail)
            || checkEmail(currentEmail);
        return (
            <FormLine
                status={validationEmailStatus ? 'standard' : 'error'}
                className="u-col--m-6 u-col--s-12"
            >
                <FormLabel>
                    Adresse mail*
                </FormLabel>
                <FormField>
                    <FormInput
                        required
                        type="email"
                        defaultValue={userEmail}
                        onChange={this.onChangeEmail}
                    />
                </FormField>
            </FormLine>
        );
    }

    renderNoOptionsMessage() {
        return 'Aucun type d\'événement trouvé';
    }

    renderTypeEvent() {
        const {
            currentEventType,
            eventTypes,
            questionErrorsDisplayed,
            isEventTypesLoading,
        } = this.props;
        const validationEventTypeStatus = !questionErrorsDisplayed
                                          || checkEventType(currentEventType);
        const selectedOption = _.find(eventTypes, { name: currentEventType });
        return (
            <FormLine
                status={validationEventTypeStatus ? 'standard' : 'error'}
                className="u-col--m-6 u-col--s-12"
            >
                <FormLabel>
                    Type d’évènement*
                </FormLabel>
                <FormField type="select">
                    <AutoSelect
                        placeholder="Choisir"
                        isClearable={false}
                        loadingPlaceholder="Chargement..."
                        noOptionsMessage={this.renderNoOptionsMessage}
                        options={eventTypes}
                        onChange={this.onChangeEventTypes}
                        isLoading={isEventTypesLoading}
                        value={selectedOption}
                        getOptionValue={this.renderOptionsValue}
                        getOptionLabel={this.renderOptionsValue}
                    />
                </FormField>
            </FormLine>
        );
    }

    renderMessage() {
        const {
            message,
            questionErrorsDisplayed,
        } = this.props;
        const validationMessageStatus = checkMessage(message) || !questionErrorsDisplayed;
        return (
            <FormLine
                status={validationMessageStatus ? 'standard' : 'error'}
            >
                <FormLabel>
                    Message*
                </FormLabel>
                <FormField type="textarea">
                    <FormTextarea
                        placeholder="Détaillez votre projet d'événement ici (nombre de participants attendus, types de participants, fonctionnalités attendues)."
                        value={message}
                        onChange={this.onChangeMessage}
                    />
                </FormField>
            </FormLine>
        );
    }

    render() {
        const {
            orga,
            user,
            currentEmail,
            currentName,
            message,
            currentEventType,
            isEventTypesLoading,
        } = this.props;
        const userEmail = user ? user.email_address : '';
        const userName = user ? `${user.first_name} ${user.last_name}` : '';
        const orgaName = orga ? orga.name : '';
        const name = currentName || orgaName || userName || '';
        const email = currentEmail || userEmail || '';
        const errorsList = salesmanFormHasErrors({
            name,
            message,
            currentEventType,
            email,
        });
        return (
            <div className="contact-form-front--bg">
                <Grid size="small" className="contact-form-front u-bg__white px--s-3" style={{ minHeight: '720px' }}>
                    <Row noCol className="px-4 py-5 px--s-0 pos_relative">
                        <BackLink />
                        <div className="u-col-12 p-0 mt-5">
                            <Title>
                                Demande commerciale
                            </Title>
                            <Form>
                                <Row vcenter>
                                    {this.renderOrgaName()}
                                    {this.renderEmail()}
                                </Row>
                                <Row vcenter>
                                    {this.renderPhone()}
                                    {this.renderTypeEvent()}
                                </Row>
                                {this.renderMessage()}
                                <ButtonContainer position="right">
                                    <Button
                                        color="premium"
                                        className="c-btn--premium"
                                        onClick={errorsList.length > 0
                                            ? undefined : this.onSendRequest}
                                        disabled={errorsList.length > 0 || isEventTypesLoading}
                                    >
                                        Envoyer
                                    </Button>
                                </ButtonContainer>
                            </Form>
                        </div>
                    </Row>
                </Grid>
            </div>
        );
    }

}

ContactSalesman.propTypes = propTypes;

ContactSalesman.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        orga: getCurrentOrgaSelector(state),
        user: getMeSelector(state),
        currentName: getCurrentNameSelector(state),
        currentEmail: getCurrentEmailSelector(state),
        eventTypes: getEventTypesSelector(state),
        currentEventType: getCurrentEventTypeSelector(state),
        phone: getCurrentPhoneSelector(state),
        message: getCurrentMessageSelector(state),
        isEventTypesLoading: isEventTypesLoadingSelector(state),
        questionErrorsDisplayed: isQuestionErrorsDisplayedSelector(state),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            setCurrentName,
            setCurrentEventType,
            setCurrentPhone,
            setCurrentEmail,
            setCurrentMessage,
            postSalesmanThread,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ContactSalesman);
